import { render, staticRenderFns } from "./DetailReturn.vue?vue&type=template&id=efc8b082"
import script from "./DetailReturn.vue?vue&type=script&lang=js"
export * from "./DetailReturn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports